import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
    colors: {
        brand: {
            50: "#eef6ff",
            100: "#d9eaff",
            200: "#bcdcff",
            300: "#8ec7ff",
            400: "#59a7ff",
            500: "#3385f4",
            600: "#1f66d8",
            700: "#1c51af",
            800: "#1d468a",
            900: "#1b3b70",
        },
    },
    fonts: {
        heading:
            "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        body: "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    },
    styles: {
        global: {
            body: {
                bg: "gray.50",
                color: "gray.800",
            },
            "::selection": {
                bg: "blue.100",
            },
        },
    },
    components: {
        Button: {
            defaultProps: {
                borderRadius: "lg",
            },
        },
    },
});

export default theme;
